import React from 'react';

const TechnicalIcon = (props) => {
  return (
    <img
      alt="Zabytek techniki"
      src="/static/images/icons/tourist_attractions/technical.svg"
      {...props}
    />
  );
};

export default TechnicalIcon;
